<template>
    <div class="center_pwd_box">
        <!-- 标题 -->
        <center-title>{{$t("message.cpwd.title")}}</center-title>
        <!-- 表单部分 -->
        <div class="center_pwd_form">
            <el-form
                :model="form" 
                :rules="rules" 
                ref="pwdForm"
                size='small' 
                label-width="150px"
                status-icon>
                <!-- 登录名 -->
                <el-form-item
                    :label="$t('message.cpwd.form1')">
                    <el-input
                        :value="user_info.username"
                        class="center_pwd_form_input"
                        disabled>
                    </el-input>
                </el-form-item>
                <!-- 原密码 -->
                <el-form-item
                    :label="$t('message.cpwd.form2')"
                    prop="old_pwd">
                    <el-input
                        v-model="form.old_pwd"
                        class="center_pwd_form_input"
                        show-password
                        clearable>
                    </el-input>
                </el-form-item>
                <!-- 新密码 -->
                <el-form-item
                    :label="$t('message.cpwd.form3')"
                    prop="new_pwd">
                    <el-input
                        v-model="form.new_pwd"
                        class="center_pwd_form_input"
                        show-password
                        clearable>
                    </el-input>
                </el-form-item>
                <!-- 确认密码 -->
                <el-form-item
                    :label="$t('message.cpwd.form4')"
                    prop="check_pwd">
                    <el-input
                        v-model="form.check_pwd"
                        class="center_pwd_form_input"
                        show-password
                        clearable>
                    </el-input>
                </el-form-item>
                <!-- 提交按钮 -->
                <el-form-item>
                    <el-button
                        type="primary"
                        @click="submitModify(form)">
                        <span>{{$t("public.submitBtn")}}</span>
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    data() {
        // 密码校验函数
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.$t("message.cpwd.rule2")));
            } else {
                // 如果新密码内容不为空，且确认密码也不为空的情况下
                if (this.form.check_pwd !== '') {
                    // 校验确认密码的有效字段
                    this.$refs.pwdForm.validateField('check_pwd');
                }
                callback();
            }
        };
        // 确认密码校验函数
        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.$t("message.cpwd.rule3")));
            } else if (value !== this.form.new_pwd) {
                callback(new Error(this.$t("message.cpwd.rule4")));
            } else {
                callback();
            }
        };
        return {
            form: {
                old_pwd: "",
                new_pwd: "",
                check_pwd: "",
            },
            rules: {
                old_pwd:[
                    { required: true, message: this.$t("message.cpwd.rule1"), trigger: 'blur' }
                ],
                new_pwd: [
                    { required: true, validator: validatePass, trigger: 'blur' }
                ],
                check_pwd: [
                    { required: true, validator: validatePass2, trigger: 'blur' }
                ],
            }
        }
    },
    computed: mapState({
        user_info: state => state.user.user_info,
        power: state => state.user.power,
    }),
    components: {
        centerTitle: () => import("@/components/center/centerTitle"),
    },
    methods: {
        ...mapActions([
            "handleModifyPwd"
        ]),
        submitModify(form){
            this.$refs.pwdForm.validate((valid) => {
                if(valid) {
                    this.handleModifyPwd({
                        oldpassword: form.old_pwd,
                        newpassword: form.new_pwd,
                    }).then((res) => {
                        if(res){
                            this.$message({
                                showClose: true,
                                message: this.$t("public.modifySucc"),
                                type: "success"
                            })
                            this.form = {
                                old_pwd: "",
                                new_pwd: "",
                                check_pwd: "",
                            }
                        }else{
                            this.$message({
                                showClose: true,
                                message: this.$t("message.cpwd.errmsg"),
                                type: "error"
                            })
                        }
                    })
                }else{
                    return false;
                }
            })
        }
    },
    beforeRouteEnter (to, from, next) {
        // ...
        next(vm => {
			setTimeout(() => {
				let allow = vm.power.includes(0) || vm.power.includes(111) || vm.power.includes(4);
				if(!allow){
				    vm.$router.back();
				    return false;
				}
			}, 500)
        })
    }
}
</script>

<style scoped>
.center_pwd_form{
    padding: 30px 0;
    background: #fff;
}
.center_pwd_form_input{
    width: 230px;
}
</style>
